var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defaultMetalCupMaterialTransform, } from "3d/types";
/** ---------------   **/
/**    PAOB Family    **/
/** ---------------   **/
export var suctionCupsFamilyPAOB = {
    PAOB: __assign(__assign({ cupModelName: "PAOB4080", cupWidth: 0.08, cupHeight: 0.04 }, defaultMetalCupMaterialTransform.NP), { fittingModelName: "G38MS01", collisionComponentType: "capsule" }),
};
